export const ID_NUMBER_LENGTH = 11
export const TAX_NUMBER_LENGTH = 10

export const INVOICE_INFO_CUSTOMERS = ['personal', 'corporate'] as const
